import { Chatbot } from 'features/chatbot/Chatbot'
import { FloatButton } from 'features/chatbot/components/FloatButton'
import { MessageCircle } from 'lucide-react'
import React, { useState } from 'react'

interface ChatbotFloatButtonProps {
  useV2?: boolean
  legacyAutoScroll?: boolean
}

export const ChatbotFloatButton: React.FC<ChatbotFloatButtonProps> = ({
  useV2 = false,
  legacyAutoScroll = false,
}) => {
  const [isChatOpen, setIsChatOpen] = useState(false)

  const toggleChat = () => {
    setIsChatOpen((open) => !open)
  }

  return (
    <FloatButton
      isOpen={isChatOpen}
      onClick={toggleChat}
      icon={<MessageCircle />}>
      <Chatbot
        onClose={() => setIsChatOpen(false)}
        useV2={useV2}
        legacyAutoScroll={legacyAutoScroll}
      />
    </FloatButton>
  )
}
